module.exports = __webpack_public_path__ + "static/media/IMG_7279_DxO.256a8f28.jpg";